import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { countryMap } from '@/shared/dictionaries/countries';
import { Select } from '@/shared/uikitV2/Select';
import { SelectProps } from '@/shared/uikitV2/Select/types';

import { Country } from '../../Country';

const COUNTRY_FIELDS = [
  'country',
  'assignedCountry',
  'countryOfAcquisition',
  'countryOfOrigin',
  'selectedCountry',
  'citizenship',
  'countryOfBirth',
];

export const SelectCountryV2: FC<SelectProps> = (props) => {
  const isCountryField = COUNTRY_FIELDS.includes(props.name as string);

  const selectOptions = isCountryField
    ? props.options
        .map((o) => {
          const info = countryMap.get(String(o.value));

          if (!info) return undefined;

          return {
            ...o,
            content: {
              label: info?.label,
              description: info?.icon,
            },
          };
        })
        .filter((option) => option !== undefined)
    : props.options;

  const iconAfter: ReactNode =
    isCountryField && !props.multiple && props.value ? (
      <Country code={String(props.value)} icon />
    ) : null;

  return (
    <StyledSelectV2
      {...props}
      status={props.status ?? 'default'}
      options={selectOptions}
      iconAfter={iconAfter}
    />
  );
};

export const StyledSelectV2 = styled(Select)`
  .option-content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: center;
    gap: 6px;
  }

  &.highlight > .select-wrapper > [role='combobox'] {
    background-color: ${COLORS.systemSun100};
  }
`;
